import { combineReducers } from 'core/redux'

import rule from './rule'

export default combineReducers({
  rule,
})
